import { styleguideControlSizes } from '@kaiizen/kai-shiki/core';
import { HexagonFilledIcon, HexagonOutlineIcon } from '@kaiizen/kai-shiki/react';
import type { StageStepperItemState, StageStepperStyles } from './stageStepperStyles';

// The number/checkmark renders on top of a hexagon marker (HexagonOutlineIcon
// for upcoming/locked, HexagonFilledIcon for done/active) instead of a bordered
// circle — Project_Comprehensive_ShopEdit.html's stage-num background swap.
export const StageNumberBadge = ({
  state,
  index,
  styles,
  measurement = false,
}: {
  state: StageStepperItemState;
  index: number;
  styles: StageStepperStyles;
  measurement?: boolean;
}) => {
  const HexagonIcon = state === 'done' || state === 'active' ? HexagonFilledIcon : HexagonOutlineIcon;

  return (
    <span data-stage-number={measurement ? undefined : 'true'} css={styles.numberBadgeByState[state]}>
      <HexagonIcon
        size={styleguideControlSizes.stageNumberSize}
        color={styles.markerColorByState[state]}
        style={{ position: 'absolute', inset: 0 }}
      />
      <span css={styles.numberTextByState[state]}>{state === 'done' ? '✓' : index + 1}</span>
    </span>
  );
};
